import React from "react";
import "../Css/Research.css";
import KeyBenefits from "../Assets/KeyBenefits.jpeg";
import PopulationsWhoBenefit from "../Assets/PopulationsWhoBenefit.jpeg";

const categories = [
  {
    id: "parkinsons",
    heading: "Parkinson's & Neurodegenerative Disease",
    studies: [
      {
        number: "1",
        title:
          "Can Table Tennis Protect the Aging Brain? A Systematic Review and Meta-Analysis in Neurodegenerative Diseases",
        link: "https://pubmed.ncbi.nlm.nih.gov/41197370/",
        keyFinding:
          "Pooling 10 studies across Alzheimer's, Parkinson's, and dementia under PRISMA methodology, table tennis was found to be a safe, feasible, and effective non-pharmacological intervention for improving cognitive and motor outcomes.",
        whyItMatters:
          "As the highest tier of current evidence — a systematic review and meta-analysis rather than a single trial — this study underpins our entire neuro-wellness model across every neurodegenerative condition we support, not just Parkinson's.",
      },
      {
        number: "2",
        title: "Table Tennis for Patients with Parkinson's Disease: A Pilot Study",
        link: "https://pmc.ncbi.nlm.nih.gov/articles/PMC8299968/",
        keyFinding:
          "Table tennis improved motor symptoms, balance, and daily functioning.",
        whyItMatters:
          "This study supports our movement‑based therapy model for Parkinson's patients, showing that table tennis can meaningfully enhance physical performance.",
      },
      {
        number: "3",
        title: "Feasibility and Effects of Table Tennis Training in Parkinson's Disease",
        link: "https://pubmed.ncbi.nlm.nih.gov/33543090/",
        keyFinding:
          "Table tennis is safe, well‑tolerated, and improves balance and mental well‑being.",
        whyItMatters:
          "This validates our program as a safe, engaging, and sustainable wellness activity for individuals with Parkinson's.",
      },
      {
        number: "4",
        title: "Quality of Life and Social Connection in Parkinson's Disease",
        link: "https://pmc.ncbi.nlm.nih.gov/articles/PMC4793007/",
        keyFinding:
          "Social relationships and communication are significantly associated with quality of life in people with Parkinson's disease.",
        whyItMatters:
          "Our group‑based, community‑centered sessions directly leverage the power of social connection to support emotional and cognitive health.",
      },
    ],
  },
  {
    id: "seniors",
    heading: "Senior Cognitive Health & Healthy Aging",
    studies: [
      {
        number: "1",
        title:
          "Effects of a 12-Week Table Tennis Training on Physical Fitness and Serum Antioxidant Parameters for Older Adults",
        link: "https://www.nature.com/articles/s41598-025-31098-8",
        keyFinding:
          "In healthy adults aged 55–65 who were beginners, 12 weeks of table tennis training produced significant improvements in single-leg balance, reaction time, and hand-grip strength.",
        whyItMatters:
          "This shows measurable benefits for general senior wellness independent of any diagnosed condition, supporting our broader healthy-aging and fall-prevention goals beyond the Parkinson's community.",
      },
    ],
  },
  {
    id: "youth",
    heading: "Youth Development",
    studies: [
      {
        number: "1",
        title:
          "Multidisciplinary Correlates of Table Tennis Participation in Children: A Concept Mapping Study",
        link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC12521237/",
        keyFinding:
          "Across 312 children aged 8–14 in a 12-month structured program, longer training duration was associated with faster reaction time, improved agility and hand-eye coordination, better executive function (Stroop/WCST performance), higher self-efficacy and social competence, and lower perceived stress.",
        whyItMatters:
          "This grounds our Youth Empowerment programming in evidence that table tennis builds cognitive, motor, and psychosocial skills together — not just athletic performance.",
      },
    ],
  },
];

const Research = () => {
  return (
    <div className="research-container">
      {/* ── Why is Table Tennis Hero ─────────────────────────── */}
      <section className="research-hero">
        <h2 className="research-hero-heading">Why is Table Tennis Beneficial?</h2>
        <div className="research-hero-images">
          <img
            src={KeyBenefits}
            alt="Key benefits of table tennis"
            className="research-hero-img research-hero-img-large"
          />
          <img
            src={PopulationsWhoBenefit}
            alt="Populations who can benefit from table tennis"
            className="research-hero-img research-hero-img-small"
          />
        </div>
      </section>

      {/* ── Studies by Category ──────────────────────────────── */}
      <div className="research-body">
        <div className="research-sidebar">
          <h2 className="research-sidebar-heading">
            The Scientific Evidence Behind Our Programs
          </h2>
        </div>

        <div className="research-content">
          {categories.map((category) => (
            <section key={category.id} className="research-studies">
              <h3 className="research-section-heading">{category.heading}</h3>

              <div className="studies-list">
                {category.studies.map((study) => (
                  <div key={study.number} className="study-card">
                    <h4 className="study-title">{study.title}</h4>

                    <p className="study-highlights">
                      <span className="study-highlights-label">
                        Highlights:
                      </span>{" "}
                      {study.keyFinding} {study.whyItMatters}
                    </p>

                    <a
                      href={study.link}
                      className="study-cta"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Read Full Study
                    </a>
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Research;